import { jsx, Fragment } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';
import { useClient, EMPTY_CLIENT } from '../../../client/ClientProvider.js';

// Provider that obtains idToken cookie if gandalfToken is given.
function AuthCookieProvider(props) {
    const client = useClient();
    const [cookieSet, setCookieSet] = useState(false);
    useEffect(() => {
        if (cookieSet) {
            return;
        }
        if (client !== EMPTY_CLIENT && props.gandalfToken) {
            client.getCookie().then(() => {
                setCookieSet(true);
            }).catch((e) => {
                console.error("Cannot set cookie", e);
            });
        }
    }, [client, cookieSet, props.gandalfToken]);
    return (!props.gandalfToken || cookieSet) ?
        jsx(Fragment, { children: props.children }) :
        jsx(Fragment, {});
}

export { AuthCookieProvider };
